<template>
  <div>
    <br />
    <br />
    <v-divider></v-divider>

    <v-row class="caption text-left">
      <v-col cols="12" lg="3" md="6"> </v-col>

      <v-col cols="12" lg="3" md="6">
        {{ $t("home.footer.app") }}
        — {{ state.app }}
      </v-col>

      <v-col cols="12" lg="3" md="6">
        {{ $t("home.footer.appVersion") }}
        — {{ state.version }}
      </v-col>

      <v-col cols="12" lg="3" md="6">
        {{ $t("home.footer.id") }}
        — {{ state.id }}
      </v-col>
    </v-row>

    <v-row class="caption text-left">
      <v-col cols="12" lg="3" md="6">
        {{ $t("home.footer.ident") }}
        — {{ state.ident }}
      </v-col>

      <v-col cols="12" lg="3" md="6">
        {{ $t("home.footer.objectIdent") }}
        — {{ state.objectIdent }}
      </v-col>

      <v-col cols="12" lg="3" md="6">
        {{ $t("home.footer.productType") }}
        — {{ state.productType }}
      </v-col>

      <v-col cols="12" lg="3" md="6">
        {{ $t("home.footer.productName") }}
        — {{ state.productName }}
      </v-col>
    </v-row>

    <v-row class="caption text-left">
      <v-col cols="12" lg="3" md="6">
        {{ $t("home.footer.serialNo") }}
        — {{ state.serialNo }}
      </v-col>

      <v-col cols="12" lg="3" md="6">
        {{ $t("home.footer.systemTime") }}
        — {{ state.systemTime }}
      </v-col>

      <v-col cols="12" lg="3" md="6">
        {{ $t("home.footer.dwSystemTime") }}
        — {{ state.dwSystemTime }}
      </v-col>

      <v-col cols="12" lg="3" md="6">
        {{ $t("home.footer.upTime") }}
        — {{ state.uptime }}
      </v-col>
    </v-row>

    <v-divider></v-divider>

    <v-row class="text-center" justify="center">
      <v-col cols="12" lg="3" md="6">
        EnergyCloud, a.s. — {{ new Date().getFullYear() }}
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "Footer",
  components: {},
  props: {
    state: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped></style>
